import { NextPage } from "next"
import { Toaster } from "react-hot-toast"

import { SignIn } from "features/auth/SignIn"
import { AuthPageTitles, RundooHead } from "layouts/components/Head"

const AuthSignInPage: NextPage = () => {
  return (
    <>
      <RundooHead headTitle={AuthPageTitles.SIGN_IN} />
      <SignIn />
      <Toaster position="bottom-center" />
    </>
  )
}

export default AuthSignInPage
